/**
 * Joins multiple URL path parts to a single one
 *
 * @param {string[]} parts - the URL path parts
 * @return {string} - the joined URL
 */
export function joinPath(...parts) {
    return parts.join('/').replace(/\/{2,}/g, '/')
}
